import { baseApi } from './baseApi';

export const teamMembersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get team members list
    listTeamMembers: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `team/list?${queryString}` : 'team/list',
        method: 'GET',
      }),
      providesTags: ['TeamMembers'],
    }),

    // Get single team member
    getTeamMember: builder.query({
      query: (teamMemberId) => ({
        url: `team/get/${teamMemberId}`,
        method: 'GET',
      }),
      providesTags: (result, error, teamMemberId) => [{ type: 'TeamMember', id: teamMemberId }],
    }),

    // Create team member
    createTeamMember: builder.mutation({
      query: (body) => ({
        url: 'team/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TeamMembers'],
    }),

    // Update team member
    editTeamMember: builder.mutation({
      query: (body) => ({
        url: 'team/edit',
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'TeamMember', id: body?.id },
        'TeamMembers',
      ],
    }),

    // Delete team member
    deleteTeamMember: builder.mutation({
      query: (teamMemberId) => ({
        url: `team/delete/${teamMemberId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TeamMembers'],
    }),
  }),
});

export const {
  useListTeamMembersQuery,
  useGetTeamMemberQuery,
  useCreateTeamMemberMutation,
  useEditTeamMemberMutation,
  useDeleteTeamMemberMutation,
} = teamMembersApi;